module.exports = __webpack_public_path__ + "img/qiwi.f8f3feaa.svg";